/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_3bf61a4d .ms-Suggestions-itemButton{padding:0px;border:none}.callout_3bf61a4d .ms-Suggestions{min-width:300px}\n"}]);
export const callout = "callout_3bf61a4d";